
import { Vue } from "vue-class-component";

export default class BkdToSti extends Vue {}
